<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <div class="text-left" style="padding-top:0%; padding-bottom: 80px; overflow-y: auto;" :style="viewStyle">
      <!-- Tabs -->
      <v-row class="ma-0 pt-2" style="padding-left: 20px; background:#FFF; position: sticky; top: 0; z-index: 3; border-bottom: 1px solid #EEE;">
        <v-tabs color="#ED6D00" background-color="transparent" v-model="tab">
          <v-tabs-slider color="#ED6D00"></v-tabs-slider>
          <v-tab>{{$t('__Staff')}}</v-tab>
          <v-tab>{{$t('__Authority')}}</v-tab>
        </v-tabs>
      </v-row>

      <div id="box" style="margin-top:3%" v-if="tab === 0">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0 primary-color" size="28">mdi-menu-right</v-icon>
          <h4 class="primary-color" style="padding-top:2px">{{$t('__profile')}}</h4>
        </v-row>

        <v-form ref="form" v-model="valid" lazy-validation :disabled="!canEdit">
          <v-row class="mx-2">
            <!-- Left Column -->
            <v-col class="pa-0 col-12 col-md-6">
              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__company')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense :readonly="!(addNewData == 0)" :background-color="!(addNewData == 0)?'#F4F8F9':'#FFF'" outlined v-model="datasets.company"></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt14" style="padding-top:10px">{{$t('__nation')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-select class="border pt14" dense outlined :readonly="!(addNewData == 0)" :background-color="!(addNewData == 0)?'#F4F8F9':'#FFF'" :items="nationList" v-model="datasets.nation"></v-select>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>{{$t('__staffName')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense :readonly="!(addNewData == 0)" :background-color="!(addNewData == 0)?'#F4F8F9':'#FFF'" outlined v-model="datasets.name"></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__title')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense :readonly="!(addNewData == 0)" :background-color="!(addNewData == 0)?'#F4F8F9':'#FFF'" outlined v-model="datasets.title"></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__tel')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.phone"></v-text-field>
                </v-col>
              </v-row>
            </v-col>

            <!-- Right Column -->
            <v-col class="pa-0 col-12 col-md-6">
              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__group')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense :readonly="!(addNewData == 0)" :background-color="!(addNewData == 0)?'#F4F8F9':'#FFF'" outlined v-model="datasets.group"></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__division')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense :readonly="!(addNewData == 0)" :background-color="!(addNewData == 0)?'#F4F8F9':'#FFF'" outlined v-model="datasets.division"></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>{{$t('__empId')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense :readonly="!(addNewData == 0)" :background-color="!(addNewData == 0)?'#F4F8F9':'#FFF'" outlined v-model="datasets.employeeId"></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14">{{$t('__mobile')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.mobile"></v-text-field>
                </v-col>
              </v-row>
            </v-col>

            <!-- Full Width Rows -->
            <v-col cols="12" class="pa-0">
              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                  <div class="text-right pt-2 pt14">{{$t('__address')}}</div>
                </v-col>
                <v-col class="col-10 col-md-10">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.address"></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                  <div class="text-right pt-2 pt14"><span class="start">*</span>{{$t('__email')}}</div>
                </v-col>
                <v-col class="col-10 col-md-10">
                  <v-text-field class="text_field" dense :readonly="!(addNewData == 0)" :background-color="!(addNewData == 0)?'#F4F8F9':'#FFF'" outlined v-model="datasets.account"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </div>

      <div id="box" v-if="tab === 0">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0 primary-color" size="28">mdi-menu-right</v-icon>
          <h4 class="primary-color" style="padding-top:2px">{{$t('__detail')}}</h4>
        </v-row>

        <v-form ref="form" v-model="valid" lazy-validation :disabled="!canEdit">
          <v-row class="mx-2">
            <v-col class="pa-0 col-12 col-md-6">
              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt14" style="padding-top:10px">{{$t('__languageSetting')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-select class="border pt14" dense outlined
                    :items="languageList" :item-text="'CodeText'" item-value="CodeType" v-model="datasets.languageSetting"></v-select>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt14" style="padding-top:10px"><span class="start">*</span>{{$t('__status')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-select class="border pt14" dense outlined
                    :items="statusList" :item-text="'CodeText'" item-value="CodeType" v-model="datasets.status"></v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="pa-0 col-12 col-md-6">
              <v-row class="ma-0 align-center" style="min-height: 48px;">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt14">{{$t('__role')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8 d-flex align-center" style="gap: 16px;">
                  <v-checkbox v-model="datasets.isManager" color="#ED6D00" class="mt-0 pt-0" hide-details :label="$t('__manager')"></v-checkbox>
                  <v-checkbox v-model="datasets.isStaff" color="#ED6D00" class="mt-0 pt-0" hide-details :label="$t('__staffRole')"></v-checkbox>
                  <v-checkbox v-model="datasets.isSales" color="#ED6D00" class="mt-0 pt-0" hide-details :label="$t('__sales')"></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </div>

      <!-- Authority Tab -->
      <div id="box" style="margin-top:3%" v-if="tab === 1">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0 primary-color" size="28">mdi-menu-right</v-icon>
          <h4 class="primary-color" style="padding-top:2px">{{$t('__Authority')}}</h4>
        </v-row>

        <v-row class="ma-2 justify-center">
          <v-col class="col-12 col-sm-10 col-md-8 pa-0">
            <div id="listTable" class="ma-0">
              <v-simple-table fixed-header>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center">{{$t('__SystemFunctions')}}</th>
                      <th class="text-center">{{$t('__View')}}</th>
                      <th class="text-center">{{$t('__Edit')}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in authorityList" :key="index">
                      <td style="min-width:230px" class="text-left pl-6">
                        <v-icon class="mr-2">{{ item.icon }}</v-icon>
                        {{ $t(item.name_i18n) }}
                      </td>
                      <td class="text-center">
                        <v-checkbox v-model="item.view" color="#ED6D00" class="d-inline-flex mt-0 pt-0" hide-details :disabled="!canEdit || item.edit"></v-checkbox>
                      </td>
                      <td class="text-center">
                        <v-checkbox v-model="item.edit" color="#ED6D00" class="d-inline-flex mt-0 pt-0" hide-details @change="handleEditCheck(item)" :disabled="!canEdit"></v-checkbox>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>

    <v-footer id="footer" class="fixed-footer">
      <div class="text-center mx-auto footer">
        <v-btn class="btn" large color="#979491" style="color: #FFF; box-shadow:none" @click="redirectPath('/Configuration')">{{$t('__cancel')}}</v-btn>
        <v-btn v-if="canEdit" class="btn" large color="#ED6D00" style="color: #FFF; box-shadow:none" @click="saveDataset()">{{$t('__confirm')}}</v-btn>
      </div>
    </v-footer>
    <ShowMsg ref="ShowMsg" :onSave="onSaveSuccess" />
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import ShowMsg from '@/dialogs/ShowMsg'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'
import { getEmployeeId, updateEmployeeInfo, getEmployeeInfo } from '@/utils/auth'

export default {
  name: 'Staff',
  components: {ShowMsg, Loading},
  data: () => ({
    isLoading: false,
    valid: true,
    viewStyle: {},
    tab: 0,
    addNewData:0, //0-新增 1-修改
    datasets: {
      id: 0,
      employeeId: '',
      account: '',
      password: '',
      name: '',
      gender: '',
      title: '',
      phone: '',
      mobile: '',
      status: '',
      role: '',
      onDutyDate: '',
      company: '',
      group: '',
      nation: '',
      division: '',
      address: '',
      function: '',
      isManager: false,
      isStaff: false,
      isSales: false,
      createTime: '',
      updateTime: ''
    },
    nationList: ['HK', 'TW', 'CN', 'SG'],
    authorityList: [
      { name_i18n: '__jobAssignmentList', icon: 'mdi-home-account', view: false, edit: false, key: 'JobAssignment' },
      { name_i18n: '__historyRecordList', icon: 'mdi-clipboard-text-clock-outline', view: false, edit: false, key: 'HistoryRecord' },
      { name_i18n: '__warrantyAndMaintenance', icon: 'mdi-tools', view: false, edit: false, key: 'WarrantyAndMaintenance' },
      { name_i18n: '__Configuration', icon: 'mdi-cog', view: false, edit: false, key: 'Configuration' }
    ],
    statusList: [
      { "CodeType": "1", "CodeText": i18n.t('__enabled') },
      { "CodeType": "0", "CodeText": i18n.t('__disabled') },
      { "CodeType": "2", "CodeText": i18n.t('__deleteBtn') }
    ],
    languageList: [
      { "CodeType": "zh-TW", "CodeText": i18n.t('__languageTw') },
      { "CodeType": "en-US", "CodeText": i18n.t('__languageEn') }
    ],
    language: ''
  }),
  computed: {
    canEdit() {
      // 如果員工已被刪除/停用(灰底)，則不允許編輯，僅供檢視
      if (this.datasets.status == '2') {
        return false
      }

      try {
        const info = getEmployeeInfo()
        if (info && info.function) {
          const perms = JSON.parse(info.function)
          const p = perms.find(e => e.key === 'Configuration')
          return p ? !!p.edit : false
        }
      } catch (e) {
        console.error('Failed to parse permissions:', e)
      }
      return false
    }
  },
  mounted() {
    this.language = i18n.locale
    this.addNewData = (this.$route.query.id == -1) ? 0 : 1
    if(this.addNewData != 0){
      this.getDataset(this.$route.query.id)
    } else {
      // Init default values for new staff
      this.datasets.id = 0;
      this.datasets.status = '1';
      this.datasets.nation = 'HK'
      this.datasets.languageSetting = 'en-US'
    }
  },
  created() {
    this.calculateWindows()
    this.$root.$on('windowInnerHeight', () => {
      this.calculateWindows()
    })
    this.$root.$on('language', (value) => {
      this.language = value
    })
  },
  methods: {
    calculateWindows() {
      this.viewStyle = {height: window.innerHeight - 135 + 'px'}
    },
    redirectPath(path) {
      this.$router.push({ path: path, query: { page: this.$route.query.page, tab: 1 } })
    },
    handleEditCheck(item) {
      if (item.edit) {
        item.view = true;
      }
    },
    getDataset(id) {
      this.isLoading = true
      var self = this
      var request = {
        method: 'GET',
        url: '/GetEmployee', 
        params: { id: id },
      }
      this.$http(request).then(function(response) {
        var data = null;
        if (response.data.Data) {
          data = response.data.Data
        } else if (response.data.data) {
          data = response.data.data
        } else {
          data = response.data
        }
        self.datasets = data;
        if (!self.datasets.languageSetting) {
          self.datasets.languageSetting = 'en-US'
        }

        // Parse role field into checkboxes
        if (self.datasets.role) {
          let roles = self.datasets.role.split(',').map(r => r.trim());
          self.datasets.isManager = roles.includes('Manager');
          self.datasets.isStaff = roles.includes('Staff');
          self.datasets.isSales = roles.includes('Sales');
        } else {
          self.datasets.isManager = false;
          self.datasets.isStaff = false;
          self.datasets.isSales = false;
        }
        
        // Map authority data if exists
        if (self.datasets.function) {
          try {
            let authList = JSON.parse(self.datasets.function);
            if (Array.isArray(authList)) {
              authList.forEach(aut => {
                let item = self.authorityList.find(a => a.key === aut.key);
                if (item) {
                  item.view = aut.view;
                  item.edit = aut.edit;
                }
              });
            }
          } catch (e) {
            console.error("Failed to parse function field", e);
          }
        }
      }).catch(() => {
        self.$refs.ShowMsg.open(0, this.$t('__error'), this.$t('__getDataError'))
      }).finally(() => {
        self.isLoading = false
      })
    },
    saveDataset() {
      if(this.tab == 0){
        if (!this.$refs.form.validate()) return
      }

      // Manual required field check
      if (!this.datasets.name || !this.datasets.employeeId || !this.datasets.status) {
        this.$refs.ShowMsg.open(1)
        return
      }

      // Email format check
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.datasets.account)) {
        this.$refs.ShowMsg.open(0, this.$t('__error'), this.$t('__invalidEmail'))
        return
      }

      this.isLoading = true
      var self = this
      // Unified endpoint for Add/Edit
      var url = '/UpdateEmployee'
      var method = 'POST' 
      
      // Build role string from checkboxes
      let roles = [];
      if (this.datasets.isManager) roles.push('Manager');
      if (this.datasets.isStaff) roles.push('Staff');
      if (this.datasets.isSales) roles.push('Sales');
      this.datasets.role = roles.join(',');

      // Update function in datasets (save as string)
      let authList = this.authorityList.map(item => ({
        key: item.key,
        view: item.view,
        edit: item.edit
      }));
      this.datasets.function = JSON.stringify(authList);

      var requestData = Object.assign({}, this.datasets)
      delete requestData.password

      var request = {
        method: method,
        url: url,
        headers: {
          'Content-Type': 'application/json-patch+json'
        },
        data: requestData
      }
      this.$http(request).then(function(response) {
        // 如果被修改的員工就是當前登入者，同步更新 localStorage 中的權限快取
        const currentEmployeeId = getEmployeeId()
        const loginAccount = sessionStorage.getItem('loginAccount') || ''
        // 以工號（employeeId 字串）或 email 帳號比對，判斷是否為當前登入者
        const isSelf = (currentEmployeeId && self.datasets.employeeId &&
        String(currentEmployeeId) === String(self.datasets.employeeId)) ||
        (loginAccount && self.datasets.account &&
        loginAccount.toLowerCase() === self.datasets.account.toLowerCase())
        if (isSelf) {
          console.log('🔄 當前登入者的角色/權限已被更新，同步更新本地快取...')
          updateEmployeeInfo({
            role: self.datasets.role,
            function: self.datasets.function
          })
          // 廣播事件通知 Home 和 Dashboard 重新載入資料
          self.$root.$emit('userPermissionsUpdated')
        }
        if (response.data.State === '988' || response.data.State === '9882' || response.data.State === '9883') {
          self.$refs.ShowMsg.open(0, self.$t('__error'), self.$t('__accountExists'))
        } else {
          self.$refs.ShowMsg.open(0, self.$t('__savedSuccessfully'), response.data.Message, true) 
        }
      }).catch((error) => {
        console.error('Save error:', error)
        var errorMsg = error.response?.data?.Message || self.$t('__saveFailed')
        self.$refs.ShowMsg.open(0, self.$t('__error'), errorMsg)
      }).finally(() => {
        self.isLoading = false
      })
    },
    onSaveSuccess() {
      this.redirectPath('/Configuration')
    },
  }
}
</script>

<style scoped>
  #box {
    background-color: white;
    border-radius: 8px;
  }
  
  .fixed-footer {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 4 !important; /* Sidebar in Home.vue is z-index 5 */
    background: white !important;
    box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.06) !important;
    padding: 13.5px 0px !important;
  }
  
  .footer .btn {
    width: 150px;
    margin: 0px 6px;
    border-radius: 8px;
  }
</style>
